
// NOTE: actual data from service
export const dashboardItems = [
  {
    title: 'Paris City Run, France',
    id: '59b1c1dc8f3a770041dbd6f1',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/2d2b5530941811e7951917cc4c84e6a7.jpg',
    workout_id: '59139e246b83fe001f2bada6',
    user_type: 'premium'
  },
  {
    title: 'Lake Louise, Alberta, Canada',
    id: '59b1c20e50d26b0040ea3ea4',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/8fa7a2d094e111e79d1d8f7942262348.jpg',
    workout_id: '57ec4b4e55fb5428005eab2f',
    user_type: 'premium'
  },
  {
    title: 'Hellbrunn Palace Run, Salzburg, Austria ',
    id: '59b1c2368f3a770041dbd6f2',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/630271c0941811e79c6e13e39a023478.png',
    workout_id: '594d558c954dcf00203f4b26',
    user_type: 'premium'
  },
  {
    id: '58223de97209e21f00ae42a1',
    type: 'navigation',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/f4504d20a5f611e6a69c55a226387a74.png',
    description: 'Explore your list of favorite workouts.',
    title: 'My Favorites',
    navigation_type: 'Favorites',
    user_type: 'all'
  },
  {
    id: '58223e103d0aec1e0058dd49',
    type: 'navigation',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/0667c3f098ac11e7a42f0f56faf2e00e.jpg',
    description: 'Discover your perfect workout from an ever-growing collection.',
    title: 'Browse the workout library',
    navigation_type: 'Library',
    user_type: 'premium'
  },
  {
    title: 'Jack\'s Point Walk, Queenstown, New Zealand',
    id: '59b1c256414fab003fcaa1c0',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/74772220941811e794231990db38fede.png',
    workout_id: '5936e62986f4e90024bc3842',
    user_type: 'premium'
  },
  {
    title: 'Shipwreck Beach Tempo Run, Studio Class',
    id: '59b1c28b50d26b0040ea3ea5',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/95acb860941811e7914db717c3e5ec8e.png',
    workout_id: '589bcfc087d01c1d006b8cf0',
    user_type: 'premium'
  },
  {
    title: 'Waterline Road, Flagstaff, Arizona',
    id: '59b1c2c99ff6ba0045b1f28c',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/b9d1f480941811e78d638bb2dc36f40e.jpg',
    workout_id: '597a07da0eefb80025dac51c',
    user_type: 'premium'
  },
  {
    title: 'Boulders Beach Walk, Cape Town, South Africa',
    id: '59b1c2ed414fab003fcaa1c1',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/cf971340941811e78d638bb2dc36f40e.jpg',
    workout_id: '58d949fc210f191e00e6b8dd',
    user_type: 'premium'
  },
  {
    title: 'Killarney National Park, Ireland',
    id: '59b1c311414fab003fcaa1c2',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/e50bef20941811e798d3551e0816dea8.png',
    workout_id: '58d03a03ad756921008f769f',
    user_type: 'premium'
  },
  {
    title: 'North Shore Beach, Hawaii',
    id: '59b1c338414fab003fcaa1c3',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/fc754800941811e7914db717c3e5ec8e.png',
    workout_id: '58fa8c7c3901de001ec8c09d',
    user_type: 'premium'
  },
  {
    title: 'Lake Louise, Alberta',
    id: '59b1c3569ff6ba0045b1f28d',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/0e29e790941911e784d14b2885a761bf.png',
    workout_id: '5894ce6cac49122400000370',
    user_type: 'premium'
  },
  {
    title: 'Dupont State Park, North Carolina',
    id: '59b1c3748f3a770041dbd6f3',
    type: 'workout',
    image_url: 'https://ifit-images.s3.amazonaws.com/equipment-featured-content/1ee81930941911e7902671dbced8c607.png',
    workout_id: '58b0b7ea567671290027bac9',
    user_type: 'premium'
  }
];

// NOTE: actual data from service
export const workoutEstimatedData = [
  {
    calories: 1022,
    elevationMetersGained: 195.573,
    elevationMetersLost: 0,
    elevationMetersNet: 195.573,
    meters: 8445.435,
    seconds: 3184,
    workoutId: '597a07da0eefb80025dac51c'
  },
  {
    calories: 376,
    elevationMetersGained: 3.935,
    elevationMetersLost: 0.436,
    elevationMetersNet: 3.499,
    meters: 3474.753,
    seconds: 1174,
    workoutId: '594d558c954dcf00203f4b26'
  },
  {
    calories: 289,
    elevationMetersGained: 82.068,
    elevationMetersLost: 17.112,
    elevationMetersNet: 64.956,
    meters: 3153.554,
    seconds: 2529,
    workoutId: '5936e62986f4e90024bc3842'
  },
  {
    calories: 261,
    elevationMetersGained: 37.844,
    elevationMetersLost: 1.186,
    elevationMetersNet: 36.658,
    meters: 2522.468,
    seconds: 1378,
    workoutId: '59139e246b83fe001f2bada6'
  },
  {
    calories: 486,
    elevationMetersGained: 0.533,
    elevationMetersLost: 0,
    elevationMetersNet: 0.533,
    meters: 4220.284,
    seconds: 9441,
    workoutId: '58fa8c7c3901de001ec8c09d'
  },
  {
    calories: 204,
    elevationMetersGained: 50.153,
    elevationMetersLost: 3.545,
    elevationMetersNet: 46.608,
    meters: 2049.589,
    seconds: 1309,
    workoutId: '58d949fc210f191e00e6b8dd'
  },
  {
    calories: 583,
    elevationMetersGained: 45.735,
    elevationMetersLost: 22.109,
    elevationMetersNet: 23.626,
    meters: 4889.277,
    seconds: 10937,
    workoutId: '58d03a03ad756921008f769f'
  },
  {
    calories: 760,
    elevationMetersGained: 66.794,
    elevationMetersLost: 38.916,
    elevationMetersNet: 27.878,
    meters: 6387.379,
    seconds: 14288,
    workoutId: '58b0b7ea567671290027bac9'
  },
  {
    calories: 394,
    elevationMetersGained: 122.939,
    elevationMetersLost: 8.06,
    elevationMetersNet: 114.879,
    meters: 3371.754,
    seconds: 1960,
    workoutId: '589bcfc087d01c1d006b8cf0'
  },
  {
    calories: 578,
    elevationMetersGained: 9.311,
    elevationMetersLost: 9.364,
    elevationMetersNet: -0.053,
    meters: 5030.724,
    seconds: 11253,
    workoutId: '5894ce6cac49122400000370'
  },
  {
    calories: 600,
    elevationMetersGained: 111.055,
    elevationMetersLost: 47.691,
    elevationMetersNet: 63.364,
    meters: 4718.566,
    seconds: 10555,
    workoutId: '57ec4b4e55fb5428005eab2f'
  }
];


// WEBPACK FOOTER //
// ./src/views/dashboard/local-data.js